import { Children, useEffect, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { rage, useObservable } from '~/rage';
import { LayoutProps } from '~/rage/utils';
import { StyledErrorBoundary } from './components/ErrorBoundary';

interface ICoreLayoutProps {
	props: LayoutProps;
	children: React.ReactNode;
}

const CoreLayout = ({ props, children }: ICoreLayoutProps) => {
	const isVisible = useObservable(
		rage.gui.getLayoutVisibleState(props.displayName!),
	);
	const isHudVisible = useObservable(rage.gui.isHudVisible());

	const shouldDisplay = useMemo(
		() => (props.isHud ? isVisible && isHudVisible : isVisible),
		[props, isVisible, isHudVisible],
	);

	useEffect(() => {
		if (!props.isHud) return;

		rage.gui
			.setGameHudVisible(shouldDisplay)
			.catch((err) => rage.notifications.showException(err));
	}, [props, shouldDisplay]);

	return (
		<StyledErrorBoundary>
			<CSSTransition
				in={shouldDisplay}
				classNames={props.displayName ?? ''}
				timeout={props.transitionTime}
				unmountOnExit
			>
				{Children.only(children)}
			</CSSTransition>
		</StyledErrorBoundary>
	);
};

export default CoreLayout;
